export default __webpack_public_path__ + "static/media/goopter-ecommerce-restaurant-ordering-process.31c8300e.png";